import {Divider} from '@/components/ui/divider/Divider'
import {PageCardWrapper, PageContent} from '@/components/ui/page-atoms/PageAtoms'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {ResumeProjectFormSections} from '@/features/projects/components/project-form/resume-project-form-sections/ResumeProjectFormSections'
import {ProjectFormHeading} from '@/features/projects/components/project-form/project-form-heading/ProjectFormHeading'
import {ResumeProjectConfirmationModal} from '@/features/projects/components/project-form/resume-project-confirmation-modal/ResumeProjectConfirmationModal'
import {useToggle} from '@/hooks/useToggle'
import {ZodSchema} from 'zod'

export const ResumeProjectFormCard = <T extends ZodSchema>({
    title,
    schema,
    projectId
}: {
    title: string
    schema: T
    projectId: string
}) => {
    const {on: showConfirmationModal, off: hideConfirmationModal, isActive: isConfirmationModalVisible} = useToggle()

    return (
        <PageCardWrapper>
            <ProjectFormHeading title={title} schema={schema} showConfirmationModal={showConfirmationModal} />
            <Divider direction="horizontal" />
            <PageContent padding={0}>
                <ScrollArea style={{height: '100%'}} scrollbar={<Scrollbar />}>
                    <ResumeProjectFormSections />
                </ScrollArea>
            </PageContent>
            {isConfirmationModalVisible && (
                <ResumeProjectConfirmationModal projectId={projectId} hide={hideConfirmationModal} />
            )}
        </PageCardWrapper>
    )
}
